<template>
  <div>
    <div class="dashboard-main-content" v-if="sail != null">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <form id="sailDetailForm">
              <div class="form-box">
              <div class="form-content pb-2">
                <div class="row justify-content-between">
                  <div class="col-lg-12">
                    <div class="card-item p-3">
                      <div class="contact-form-action">
                        <div class="row m-3">
                          <h3 class="title">Sefer</h3>
                          <div class="ml-4">
                            <button type="button"
                                @click="generateManifest()"
                                class="theme-btn w-20" style="line-height: 25px;">
                              <i class="las la-print"></i>
                              Manifesto Oluştur
                            </button>
                          </div>
                          <div class="ml-4">
                            <button type="button"
                                    @click="generateOperationManifest()"
                                    class="theme-btn w-20" style="line-height: 25px;">
                              <i class="las la-print"></i>
                              Operasyon Manifesto Oluştur
                            </button>
                          </div>
<!--                          <div class="ml-4" v-if="projectName === 'miray'">-->
<!--                            <button type="button"-->
<!--                                    @click="openExportToLogoModal()"-->
<!--                                    class="theme-btn w-20" style="line-height: 25px;">-->
<!--                              <i class="las la-cloud-upload-alt"></i>-->
<!--                              Logoya Aktar-->
<!--                            </button>-->
<!--                          </div>-->
                          <div class="ml-4" v-if="projectName === 'miray'">
                            <button type="button"
                                    @click="openProformaStatusModal()"
                                    class="theme-btn w-20" style="line-height: 25px;">
                              <i class="las la-cloud-upload-alt"></i>
                              Proforma Durumu
                            </button>
                          </div>
                          <div class="ml-4" v-if="projectName === 'miray' && panelRights['PANEL_INVOICE_GET_AGENCY_INVOICE_STATUS']">
                            <button type="button"
                                    @click="openInvoiceStatusModal()"
                                    class="theme-btn w-20" style="line-height: 25px;">
                              <i class="las la-cloud-upload-alt"></i>
                              Fatura Durumu
                            </button>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <base-select-input
                              v-model="sail.cruiseId"
                              :optionList="cruiseList"
                              :rules="'required'"
                              :label="'Cruise'"
                              :href="basePath+'/cruises/'+sail.cruiseId"
                              :href-text="sail.cruiseId">
                          </base-select-input>
                          <base-select-input
                              v-model="sail.seaTourId"
                              :optionList="seaTourList"
                              :rules="'required'"
                              :label="'Tur'"
                              :href="basePath+'/seatours/'+sail.seaTourId"
                              :href-text="sail.seaTourId">
                          </base-select-input>
                          <base-select-input
                              v-model="sail.pricingTemplateId"
                              :optionList="priceList"
                              :rules="'required'"
                              :label="'Ücret Tarifesi'"
                              :href="basePath+'/pricings/'+sail.pricingTemplateId"
                              :href-text="sail.pricingTemplateId">
                          </base-select-input>
                          <base-select-input
                              v-model="sail.additionalServicePricingTemplateId"
                              :optionList="additionalServicePriceList"
                              :rules="'required'"
                              :label="'Ücret Tarifesi'"
                              :href="basePath+'/additional-service/pricings/'+sail.additionalServicePricingTemplateId"
                              :href-text="sail.pricingTemplateId">
                          </base-select-input>
                        </div>
                        <div class="col-sm-6">
                          <div class="input-box">
                            <label class="label-text">Resim</label>
                            <base-image-edit-input
                                v-model="sail.imageUrl">
                            </base-image-edit-input>
                          </div>
                          <div class="input-box">
                            <label class="label-text">Sefer Tarihi *</label>
                            <div class="form-group">
                              <span class="la la-calendar form-icon"></span>
                              <input class="form-control" type="text"  id="sailDateInput" style="padding-left: 40px!important;">
                            </div>
                          </div>
                          <div class="input-box">
                            <label class="label-text">Satışa Açık</label>
                            <div class="form-group">
                              <input class="form-control" v-model="sail.saleOpen" type="checkbox" placeholder="">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="btn-box">
                            <button v-if="sail.id == null" :class="{'disabled' : !formValid}" @click="create" class="theme-btn" type="button">Kaydet</button>
                            <button v-if="sail.id != null" :class="{'disabled' : !formValid}" @click="update" class="theme-btn" type="button">Güncelle</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section-block mb-4"></div>
                <div class="row" v-if="sail.id != null">
                  <div class="col-lg-12">
                    <sail-route-list/>
                  </div>
                </div>
                <div class="section-block mb-4"></div>
                <div class="row" v-if="sail.id != null">
                  <div class="col-lg-12">
                    <sail-deck-list/>
                  </div>
                </div>
              </div>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="sail != null">
      <sail-route-detail></sail-route-detail>
      <cruise-room-detail></cruise-room-detail>
      <sail-deck-detail></sail-deck-detail>
      <export-to-logo-popup/>
      <export-to-logo-web-agency-popup/>
      <sail-proforma-status-popup/>
<!--      <sail-invoice-status-popup/>-->
    </div>
  </div>
</template>

<script>
import SailRouteList from "./SailRouteList";
import CruiseRoomList from "../cruise/cruiseroom/CruiseRoomList";
import SailRouteDetail from "./SailRouteDetail";
import CruiseRoomDetail from "../cruise/cruiseroom/CruiseRoomDetail";
import SailDeckList from "./SailDeckList";
import SailDeckDetail from "./SailDeckDetail";
import BaseSelectInput from "../base/BaseSelectInput";
import validationFormUtils from "../../util/validationFormUtils";
import BaseEditInput from "../base/BaseEditInput";
import BaseImageEditInput from "../base/BaseImageEditInput";
import ExportToLogoPopup from "../booking/ExportToLogoPopup";
import SailProformaStatusPopup from "../booking/SailProformaStatusPopup";
import ExportToLogoWebAgencyPopup from "../booking/ExportToLogoWebAgencyPopup";
import SailInvoiceStatusPopup from "../booking/SailInvoiceStatusPopup";

export default {
  name: "SailDetail",
  components: {
    SailInvoiceStatusPopup,
    ExportToLogoWebAgencyPopup,
    SailProformaStatusPopup,
    ExportToLogoPopup,
    BaseEditInput,
    BaseSelectInput,
    BaseImageEditInput,
    SailDeckDetail, SailDeckList, CruiseRoomDetail, SailRouteDetail, CruiseRoomList, SailRouteList},
  data:function (){
    return{
      formValid:false
    }
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath;
      }
    },
    sail:{
      get(){
        return this.$store.getters.getSail;
      }
    },
    priceList:{
      get(){
        return this.$store.getters.getPriceList;
      }
    },
    additionalServicePriceList:{
      get(){
        return this.$store.getters.getAdditionalServicePricingTemplateList;
      }
    },
    cruiseList:{
      get(){
        return this.$store.getters.getCruiseList;
      },
    },
    seaTourList:{
      get(){
        return this.$store.getters.getSeaTourList;
      }
    },
    projectName:{
      get(){
        return this.$store.getters.getProjectName;
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    setTimeout(()=>{
      this.$nextTick(()=>{
        $('.select-contain-select').selectpicker('refresh')
        $('#sailDateInput').mask('00/00/0000');
        $("#sailDateInput").daterangepicker({
          opens: 'right',
          singleDatePicker: true,
          startDate: new Date(),
          minDate:new Date(),
          locale: {
            format: 'DD/MM/YYYY',
          }
        });

        $("#sailDateInput").val(moment.utc(new Date(this.sail.sailDate),"YYYY-MM-DD").format("DD/MM/YYYY"));
        let that = this;
        $("#sailDateInput").change(function(){
          that.sail.sailDate = moment.utc($(this).val(),'DD/MM/YYYY').format('DD/MM/YYYY');
        });
        this.$nextTick(()=> {
          $('.select-contain-select').selectpicker('refresh')
        })
      })
    },150)
  },
  methods:{
    generateManifest(){
      this.$store.dispatch("getSailManifest", {sailId:this.sail.id}).then((response)=>{
        window.open(response, '_blank').focus();
      });
    },
    generateOperationManifest(){
      window.open(this.$store.getters.getServiceUrl + "/admin-api/report/operation-manifest/"
                                  +this.sail.id+"?xauth="+this.$store.getters.getToken.token, '_blank').focus();
    },
    create(){
      if(this.formValid){
        this.$store.dispatch("createSail").then(response => {
          $(".modal").modal('hide')
          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: '',
          })
        })
      }
    },
    update(){
      if(this.formValid){
        this.$store.dispatch("updateSail")
        .then(() => {
            $(".modal").modal('hide')
            Swal.fire({
              icon: 'success',
              title: 'Başarılı',
              text: '',
            })
        })
      }
    },
    openExportToLogoModal(){
      $("#exportToLogoPopup").modal("show");
    },
    openProformaStatusModal(){
      $("#sailProformaStatusPopup").modal("show");
    },
    openInvoiceStatusModal(){
      $("#sailInvoiceStatusPopup").modal("show");
    },
    initDateInput(){
      $('#sailDateInput').mask('00/00/0000');
    },
  },
  watch:{
    sail:{
      deep:true,
      handler:function (){
        validationFormUtils.checkFormFields(this);
      }
    }
    // ,
    // "sail.sailDate":{
    //   deep:true,
    //   handler:function (){
    //     $('#sailDateInput').mask('00/00/0000');
    //   }
    // }
  }
}
</script>

<style scoped>

</style>